import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

import { NotQualifiedReason } from '@front/pro/src/types/pro';

type QueryParamList = { paramKey: string; paramValue: NotQualifiedReason | undefined }[];

export const useNavigateHistoryWithQuery = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const historyPushWithQuery = useCallback(
    (pathname: string, queryParamList: QueryParamList = []) => {
      const params = new URLSearchParams(search);
      queryParamList.forEach(({ paramKey, paramValue }) => {
        if (paramValue) params.append(paramKey, paramValue);
      });

      navigate({ pathname, search: params.toString() });
    },
    [navigate, search],
  );

  const historyReplaceWithQuery = useCallback(
    (pathname: string) => {
      navigate({ pathname, search }, { replace: true });
    },
    [navigate, search],
  );

  return { historyPushWithQuery, historyReplaceWithQuery };
};
